import { render, staticRenderFns } from "./DownloadSuccessful.vue?vue&type=template&id=2e287e2a&scoped=true&"
import script from "./DownloadSuccessful.vue?vue&type=script&lang=js&"
export * from "./DownloadSuccessful.vue?vue&type=script&lang=js&"
import style0 from "./DownloadSuccessful.vue?vue&type=style&index=0&id=2e287e2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e287e2a",
  null
  
)

export default component.exports